import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const AllPlans = lazy(() => import('@pages/affiliate/AllPlans'));

export const AllPlansRoutes: RouteObject[] = [
  {
    path: '/all-plans',
    element: (
      <React.Suspense>
        <AllPlans />
      </React.Suspense>
    ),
  },
]; 